import type { Script } from '@unhead/schema'
import useGlobalConfig from './useGlobalConfig'
import { useHead } from '#imports'

export const useHtfScripts = () => {
  const { htfFeatures } = useGlobalConfig()

  const getHtfScripts = () => {
    if (!htfFeatures.value) {
      return null
    }

    return htfFeatures.value.reduce<Script[]>(
      (acc, { active, scriptIsBoot, scriptSrc }) => {
        if (active && scriptIsBoot && scriptSrc) {
          acc.push({
            type: 'text/javascript',
            src: `https://order-hd01.madeleine.com/htf/${scriptSrc}`,
            tagPriority: 'critical',
          })
        }
        return acc
      },
      [],
    )
  }

  const load = () => {
    if (import.meta.client) {
      return
    }

    const scripts = getHtfScripts()
    if (!scripts?.length) {
      return
    }

    useHead({ script: scripts })
  }

  return { load }
}
